<template>
  <div>
    <v-btn
      v-if="item.confirmed === null"
      @click="toggle(item)"
      class="ml-auto"
      color="white"
      elevation="0"
      icon
    >
      <v-icon color="primary">mdi-tooltip</v-icon>
    </v-btn>
    <div class="ml-auto" v-else >
      <v-icon v-if="item.confirmed" color="success">mdi-tooltip-check</v-icon>
      <v-icon v-else color="error">mdi-tooltip-remove</v-icon>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  components: { },
  name: "PayoutsListActions",
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  methods: {
    ...mapMutations("payouts", ["setShowModal"]),

    toggle(item) {
      this.setShowModal(item);
    },
  },
};
</script>
